import {ACCEPTED_DOCUMENT_MIME_TYPES, MAX_DOCUMENT_FILE_SIZE_BYTES} from "@mytour/shared";

export function validateDocumentFile(file: File): string | null {
  if (file.name.length === 0 || file.name.length > 255) {
    return "Nom de fichier invalide (1 à 255 caractères)";
  }
  if (file.size === 0) {
    return "Fichier vide";
  }
  if (file.size > MAX_DOCUMENT_FILE_SIZE_BYTES) {
    const maxMb = Math.round(MAX_DOCUMENT_FILE_SIZE_BYTES / (1024 * 1024));
    return `Fichier trop volumineux (max ${maxMb} Mo)`;
  }
  if (!ACCEPTED_DOCUMENT_MIME_TYPES.includes(file.type as never)) {
    return `Type de fichier non accepté (${file.type || "inconnu"})`;
  }
  return null;
}
